const domain = process.env.REACT_APP_DOMAIN

const TOKEN_KEY = "crm_auth_token";
const SUPER_ADMIN_TOKEN_KEY = "crm_super_admin_token";

let cachedUser = null;
let inFlightPromise = null;

export const getAuthToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// Super Admin token helpers (separate from regular user token)
export const getSuperAdminToken = () => localStorage.getItem(SUPER_ADMIN_TOKEN_KEY);
export const setSuperAdminToken = (token) => localStorage.setItem(SUPER_ADMIN_TOKEN_KEY, token);
export const removeSuperAdminToken = () => localStorage.removeItem(SUPER_ADMIN_TOKEN_KEY);
export const getSuperAdminHeaders = () => {
  const token = getSuperAdminToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export async function login({ email, password }) {
  try {
    const res = await fetch(`${domain}/api/v1/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();
    
    if (data.success && data.token) {
      setAuthToken(data.token);
    }
    
    return data;
  } catch (err) {
    throw err;
  }
}

export async function getCurrentUser() {
  try {
    const token = getAuthToken();
    if (!token) {
      return { success: false, user: null };
    }

    if (cachedUser) {
      return cachedUser;
    }

    if (inFlightPromise) {
      return inFlightPromise;
    }

    inFlightPromise = (async () => {
      const response = await fetch(`${domain}/api/v1/user/get`, {
        method: "GET",
        headers: getAuthHeaders(),
      });

      if (response.status === 401 || response.status === 403) {
        cachedUser = null;
        inFlightPromise = null;
        removeAuthToken();
        window.location.href = "/";
        return { success: false, user: null };
      }

      if (!response.ok) {
        inFlightPromise = null;
        return { success: false, user: null, error: "Server error" };
      }

      const data = await response.json();

      cachedUser = data;
      inFlightPromise = null;

      return data;
    })();

    return inFlightPromise;
  } catch (err) {
    inFlightPromise = null;
    return { success: false, user: null };
  }
}
export async function createUser({ name, email, contact_number, user_role = "business_admin", password }) {
  try {
    const res = await fetch(`${domain}/api/v1/user/create`, {
      method: "POST",
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({ name, email, contact_number, user_role, password }),
    });
    const data = await res.json();
    
    // if (data.success && data.token) {
    //   setAuthToken(data.token);
    // }
    
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendOTP({ email}) {
  try {
    const res = await fetch(`${domain}/api/v1/auth/send-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}
export async function sendPasswordResetOTP({ email}) {
  try {
    const res = await fetch(`${domain}/api/v1/auth/send-password-reset-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export async function verifyOTP({ email, otp}) {
  try {
    const res = await fetch(`${domain}/api/v1/auth/verify-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, otp }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export async function setPassword({ email, reset_token, newPassword }) {
  try {
    const res = await fetch(`${domain}/api/v1/auth/set-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, reset_token, newPassword }),
    });
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export async function logout() {
  try {
    const res = await fetch(`${domain}/api/v1/auth/logout`, {
      method: "POST",
      headers: getAuthHeaders(),
    });
    const data = await res.json();
    
    removeAuthToken();
    
    return data;
  } catch (err) {
    removeAuthToken();
    throw err;
  }
}

export const updateUserProfile = async (userId, formData) => {
  try {
    const response = await fetch(`${domain}/api/v1/user/update/${userId}`, {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(formData),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, error: "Network error" };
  }
};
